import SvgIcon from '@mui/material/SvgIcon'

export default function ReplyIcon(props) {
  return (
    <SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11"></path>
    </SvgIcon>
  )
}
